export const environment = {
  name: 'dev',
  production: false,
  i18nVersion: '20261019g',
  apiUrl: 'https://dev-ims.intedgroup.com/api-v2/',
  ecole: 'app',
  microsoftClientId: '89f2bd37-9f15-41bf-b34e-7682cbfd8e25',
  googleClientId: '768694528876-141gr4sa431c7b67tdi2n3m8sgorrioo.apps.googleusercontent.com',
  azureUrl: 'https://imscloudsdev.blob.core.windows.net',
  storageAccountName: 'imscloudsdev'
};
